module.exports = __webpack_public_path__ + "img/select.df8e3add.svg";